<template>
  <div>
    <Breadcrumb origin-name="Communities" origin-path="/communities" :current-name="community.name" />
    <List :columns="columns" :values="moderators" emptyText="Bisher keine Moderatoren vorhanden">
      <template #column_name="{data}">{{ data.firstName }} {{ data.lastName }}</template>
      <template #column_action="{data}">
        <div class="d-flex justify-content-center">
          <img @click="moderatorToDelete = data" src="../../assets/icons/remove.svg" />
        </div>
      </template>
    </List>
    <Dialog :visible="moderatorToDelete"
            title="Moderator entfernen?"
            ok-button-text="Ja, entfernen!"
            @cancel="moderatorToDelete = undefined"
            @ok="removeModerator"
            :message="`Wollen Sie ${moderatorToDelete ? moderatorToDelete.firstName : ''} ${moderatorToDelete ? moderatorToDelete.lastName : ''} wirklich entfernen?`">
    </Dialog>
  </div>
</template>

<script>
import Breadcrumb from "@/components/partial/Breadcrumb.vue";
import {communicator} from "@/util/communicator";
import {broadcast} from "@/util/eventHandler";
import List from "@/components/partial/List.vue";
import Dialog from "@/components/partial/Dialog.vue";

export default {
  components: {Dialog, List, Breadcrumb},
  name: "Moderator",
  data() {
    return {
      moderatorToDelete: undefined,
      moderators: [],
      community: [],
      columns: [
        { name: "Name", key: "name" },
        { name: "E-Mail Adresse / Telefonnummer", key: "email" },
        { name: "Aktion", key: "action", styles: { width: "75px" } },
      ]
    };
  },
  created() {
    if(this.$route.params.id) {
      this.loadModerator(this.$route.params.id);
      this.community = this.$store.state.communities.find(e => String(e.id) === this.$route.params.id);
    }
  },
  methods: {
    async loadModerator(id) {
      try {
        const response = await communicator.get("/communities/" + id + "/moderator");
        let items = response.data.items;
        // If email is empty, use msisdn as email
        items.forEach(item => {
          if (item.email === null || item.email.trim() === "") {
            item.email = item.msisdn;
          }
        });

        this.moderators = items;
      } catch (e) {
        broadcast("error", e.response.data);
      }
    },
    async removeModerator() {
      try {
        await communicator.delete("/communities/" + this.$route.params.id + "/moderator/" + this.moderatorToDelete.id);
        this.moderatorToDelete = undefined;
        this.loadModerator(this.$route.params.id);
      } catch (e) {
        broadcast("error", e.response.data);
      }
    }
  }
};
</script>

<style lang="scss">
  .d-flex img:hover {
    cursor: pointer;
  }
</style>
